var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg118(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36.727,
    viewBox: "0 0 48 36.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_1_",
    "data-name": "team (1)",
    transform: "translate(0 -60.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(15.782 92.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M169.042,404.814a.7.7,0,0,0-.7.7v3.006a.7.7,0,0,0,1.406,0v-3.006A.7.7,0,0,0,169.042,404.814Z",
    transform: "translate(-168.339 -404.814)",
    fill: "#f24462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(30.812 92.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M329.364,404.814a.7.7,0,0,0-.7.7v3.006a.7.7,0,0,0,1.406,0v-3.006A.7.7,0,0,0,329.364,404.814Z",
    transform: "translate(-328.661 -404.814)",
    fill: "#f24462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(5.261 76.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M61.64,237.3a13.711,13.711,0,0,0-4.824-.826.7.7,0,0,0,0,1.406,12.166,12.166,0,0,1,4.195.677.7.7,0,0,0,.629-1.258Z",
    transform: "translate(-56.113 -236.476)",
    fill: "#f24462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(3.006 90.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M32.767,388.782a.7.7,0,0,0-.7.7v4.509a.7.7,0,0,0,1.406,0v-4.509A.7.7,0,0,0,32.767,388.782Z",
    transform: "translate(-32.064 -388.782)",
    fill: "#f24462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(0 60.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M46.365,88.307l-2.847-1.424a.048.048,0,0,1-.027-.043V85.409a5.192,5.192,0,0,0,2.2-3.57,5.946,5.946,0,0,0-1.58-7.744,3.017,3.017,0,0,0,.129-.871,3.73,3.73,0,0,0-7.418,0,3.016,3.016,0,0,0,.128.871A5.994,5.994,0,0,0,35,76.638c-.174-1.713-.356-3.737-.53-6.1a11.638,11.638,0,0,0-3.236-7.6A10.057,10.057,0,0,0,24,60.121a10.057,10.057,0,0,0-7.234,2.821,11.638,11.638,0,0,0-3.236,7.6c-.061.826-.123,1.609-.185,2.355H6.715a4.466,4.466,0,0,0-4.461,4.461V77.4a3.728,3.728,0,0,0,.392,1.659l.36.72v1.148A5.485,5.485,0,0,0,5.26,85.36v1.016a.294.294,0,0,1-.213.282l-2.9.829A2.97,2.97,0,0,0,0,90.331v5.814a.7.7,0,0,0,1.406,0V90.331a1.558,1.558,0,0,1,1.125-1.492l2.9-.829a1.669,1.669,0,0,0,.3-.119l1.782,1.782v6.472a.7.7,0,0,0,1.406,0V89.673l1.794-1.794a3.852,3.852,0,0,0,.654.236l.713.2a3.71,3.71,0,0,0-1.561,3.022v4.805a.7.7,0,1,0,1.406,0V91.34A2.3,2.3,0,0,1,13.3,89.233l4.02-1.776a7.469,7.469,0,0,0,13.361,0L34.7,89.233a2.3,2.3,0,0,1,1.373,2.107v4.805a.7.7,0,0,0,1.406,0V91.34a3.708,3.708,0,0,0-.888-2.405l1.088-.544.817.776a2.956,2.956,0,0,0,4.075,0l.817-.776,2.349,1.174a1.543,1.543,0,0,1,.858,1.388v5.193a.7.7,0,1,0,1.406,0V90.952A2.942,2.942,0,0,0,46.365,88.307ZM40.533,71.3a2.143,2.143,0,0,1,2.3,1.927c0,.045,0,.089-.007.133a5.957,5.957,0,0,0-4.591,0c0-.044-.007-.088-.007-.133A2.143,2.143,0,0,1,40.533,71.3ZM8.218,88.387l-1.6-1.6a1.683,1.683,0,0,0,.051-.41v-.3a4.926,4.926,0,0,0,1.392.246l.162,0a5.222,5.222,0,0,0,1.549-.234v.282a1.932,1.932,0,0,0,.044.417ZM8.1,84.919a3.934,3.934,0,0,1-3.688-3.993V79.612a.7.7,0,0,0-.074-.314L3.9,78.429a2.316,2.316,0,0,1-.243-1.03v-.042A3.058,3.058,0,0,1,6.715,74.3h6.061v2.919a3.069,3.069,0,0,1-.323,1.366l-.355.71a.7.7,0,0,0-.074.314v1.5a3.806,3.806,0,0,1-3.924,3.8ZM13.977,87.4l-2.221-.635c-.58-.166-.58-.23-.58-.387v-.969a5.193,5.193,0,0,0,1.069-.983,1.442,1.442,0,0,0,.51.574,15.526,15.526,0,0,0,3.191,1.53ZM24,90.181a6.054,6.054,0,0,1-5.393-3.292l1.023-.452a2.207,2.207,0,0,0,1.315-2.018V82.732a8.215,8.215,0,0,0,6.109,0v1.687a2.207,2.207,0,0,0,1.315,2.018l1.023.452A6.04,6.04,0,0,1,24,90.181Zm6.1-4.518-1.16-.512a.8.8,0,0,1-.477-.732V82a8.218,8.218,0,0,0,3.758-6.9V73.784a2.932,2.932,0,0,0-1-2.218c-1.413-1.229-4.611-3.373-10.155-3.927a.7.7,0,1,0-.14,1.4c5.157.516,8.085,2.47,9.372,3.589a1.527,1.527,0,0,1,.516,1.156V75.1a6.812,6.812,0,1,1-13.624,0v-.588a.766.766,0,0,1,.4-.662,5.566,5.566,0,0,0,2.569-3.036.7.7,0,0,0-1.334-.445,4.181,4.181,0,0,1-1.937,2.262,2.185,2.185,0,0,0-1.105,1.881V75.1A8.218,8.218,0,0,0,19.539,82v2.417a.8.8,0,0,1-.477.732l-1.16.512a15.532,15.532,0,0,1-4.383-1.846.035.035,0,0,1-.017-.041c.245-1.45.875-5.631,1.429-13.131a10.26,10.26,0,0,1,2.821-6.7A8.68,8.68,0,0,1,24,61.527a8.68,8.68,0,0,1,6.247,2.417,10.261,10.261,0,0,1,2.821,6.7c.554,7.5,1.184,11.681,1.429,13.131a.035.035,0,0,1-.017.041A15.537,15.537,0,0,1,30.1,85.663Zm7.479,1.177a.048.048,0,0,1-.027.043l-2.2,1.1c-.026-.012-.051-.026-.078-.038l-3.215-1.42A15.53,15.53,0,0,0,35.245,85a1.445,1.445,0,0,0,.639-1.456l-.017-.1a5.2,5.2,0,0,0,1.708,1.966ZM41.6,88.147a1.55,1.55,0,0,1-2.137,0l-.654-.621a1.455,1.455,0,0,0,.171-.686v-.748a5.233,5.233,0,0,0,3.1,0v.748a1.455,1.455,0,0,0,.171.687Zm-1.069-3.227a3.8,3.8,0,0,1-3.782-3.391.7.7,0,0,0-.1-.292,4.558,4.558,0,1,1,8.208-.955,13.055,13.055,0,0,0-5.678-2.86.7.7,0,0,0-.854.687,1.719,1.719,0,0,1-.546,1.006.7.7,0,0,0,.994.994,3.4,3.4,0,0,0,.764-1.136c1.183.351,3.639,1.239,4.741,2.8A3.8,3.8,0,0,1,40.533,84.921Z",
    transform: "translate(0 -60.121)",
    fill: "#f24462"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(43.588 91.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M465.639,398.692a.7.7,0,0,0-.7.7v3.58a.7.7,0,0,0,1.406,0V399.4A.7.7,0,0,0,465.639,398.692Z",
    transform: "translate(-464.936 -398.692)",
    fill: "#f24462"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg118);
export default __webpack_public_path__ + "static/media/118.e0e6ee88.svg";
export { ForwardRef as ReactComponent };